<template>
  <v-container>
    <v-row class="pb-2">
      <v-col cols="5">
        <v-text-field
            hide-details="auto"
            outlined
            dense
            clearable
            v-model="filter['ministry_id']"
            label="経産省ID"
            v-on:keyup.enter="handle"
        ></v-text-field>
      </v-col>
      <v-col cols="5">
        <v-text-field
            hide-deails="auto"
            outlined
            dense
            clearable
            v-model="filter['plant_address']"
            label="住所"
            v-on:keyup.enter="handle"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn color="primary" height="40" block @click="searchPlant">
          <v-icon left>mdi-magnify-plus</v-icon>
          検索
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
        dense
        hide-default-footer
        :headers="tableHeaders"
        :items="plants"
        :page.sync="filter.page"
        :items-per-page="filter.per_page"
        :server-items-length="totalPlants"
        :loading="loading"
        loading-text="ローディング..."
        no-data-text="該当データがありません。"
        class="elevation-1"
        @click:row="(plant) => {
          showPolygon(plant)
      }" 
        
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <b>発電所一覧</b>
            <span>（{{ totalPlants }} 件）</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="text-right">
            <v-pagination
                v-if="totalPlants > 0"
                v-model="filter.page"
                :length="totalPlants == 0 ? 0 : Math.ceil(totalPlants/10)"
                total-visible="9"
                @input="changePage"
            ></v-pagination>
          </div>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item.ministryId="{ item }">
            <v-btn
            color="primary" text
            @click="showPolygon(item)"
            >{{item.ministryId}}</v-btn>
      </template>
      <template v-slot:item.dc="{ item }">
        {{item.dc}}
      </template>
      <template v-slot:item.status="{ item }"> 
        <div>
          <div
          style="width: 106px; display:inline-block;"
          >
            <v-chip
              v-if="item.inputMethod === 'KANBAN'"
              color="yellow lighten-3"
              small
            >
              看板撮影済み
            </v-chip>
          </div>
          <!-- <v-chip
            v-if="item.inputMethod === 'KANBAN'"
            color="yellow lighten-3"
            small
          >
            看板撮影済み
          </v-chip> -->
          <v-chip
              :color='item.check_AI ? "cyan lighten-4" : "default"'
              class="chip"
              small
          >
            {{ getStatusAIText(item) }}
          </v-chip>
          <v-chip
              v-if="item.check_polygon_status ==='FLIGHT_AREA_CONFIRMED'"
              color="primary"
              small
          >
            フライト範囲確定済み
          </v-chip>
          <v-chip
              v-if="item.check_flight_status == true"
              color="success"
              small
          >
            撮影完了
          </v-chip>
        </div>
        
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import {store} from "@/store";
export default {
  name: "PfsMainPlant",

  data: () => ({
    filter: {
      'ministry_id': store.state.pfs_search_filter.ministry_id,
      'plant_address': store.state.pfs_search_filter.plant_address,
      page: parseInt(store.state.pfs_search_filter.page),
      per_page: 10,
    },
    loading: true,
    tableHeaders: [
      {
        text: "経産省ID",
        sortable: false,
        value: "ministryId",
      },
      {
        text: "住所",
        sortable: false,
        value: "representativeAddress",
      },
      {
        text: "DC出力(kw)",
        sortable: false,
        value: "dc",
      },
      {
        text: "状況",
        sortable: false,
        value: "status",
      },
    //   {
    //     text: "アクション",
    //     sortable: false,
    //     value: "actions",
    //     align: 'center',
    //   },
    ],
    totalPlants: 0,
    plants: [],
    selectedPlantId: null,
  }),

  methods: {
    resetData() {
      this.loading = true;
      this.totalPlants = 0;
      this.plants = [];
    },
    getMainPlants() {
      this.resetData();
      if (this.filter.plant_name){
        this.filter.ministry_id = this.filter.plant_name.trim().replaceAll("\\p{Z}", "");
      }
      if (this.filter.plant_address){
        this.filter.plant_address = this.filter.plant_address.trim().replaceAll("\\p{Z}", "");
      } else {
        this.filter.plant_address = "";
      }
     
      this.axios
          .post("/api/pfs/main-plants", this.filter)
          .then((response) => {
            this.loading = false;
            this.plants = response.data.listPlants;
            this.totalPlants = response.data.total;
          });
    },
    changePage() {
      this.getMainPlants();
      store.updatePfsSearchFilter(this.filter);
    },
    searchPlant() {
      this.filter.page = 1;
      this.getMainPlants();
      store.updatePfsSearchFilter(this.filter);
    },
    getStatusAIText(item) {
        if(item.check_AI) {
            const text = "AI抽出済み";
            return text;
        } else {
            const text = "AI未抽出";
            return text;
        }
    },
    
    handle() {
      this.searchPlant();
    },
    showPolygon(item) {
        this.$router.push('/pfs/' + item.powPlantId + '/polygon');
    }

  },

  created() {
    this.getMainPlants();
  },
}
</script>

<style scoped>
.elevation-1 >>> tbody tr :hover {
  cursor: pointer;
}
.v-input--selection-controls {
    margin-top: 0px;
}
.chip {
  width: 83px;
  justify-content: center;
}
</style>
